import { mobileSlider } from './scripts';

(function () {

  window.addEventListener("DOMContentLoaded", function () {
    mobileSlider(".documents-archive .documents-slider", ".swiper-pagination--documents-archive");
  });
})();
